import React from "react";

const InfoSection2 = () => {
const steps = [
  {
    icon: "puzzle-piece-fill.svg",
    title: "Projekt finden",
    description:
      "Unternehmen erstellen Projektangebote – Talente erhalten passende Vorschläge oder suchen aktiv nach Herausforderungen.",
    type: "projects",
  },
  {
    icon: "plugs-connected-fill.svg",
    title: "Match erhalten",
    description:
      "Qlance gleicht Interessen, Skills und Verfügbarkeiten ab – und verbindet passende Partner automatisch.",
    type: "talents",
  },
  {
    icon: "users-three-fill.svg",
    title: "Zusammenarbeiten",
    description:
      "Nach dem Match startet die direkte Zusammenarbeit. Kommunikation und Fortschritt erfolgen über die Plattform.",
    type: "companies",
  },
];

  return (
    <section className="info2-section" id="workflow">
      <div className="info2-container">
        <p className="info2-topline">Wenn aus Ideen echte Projekte werden</p>
        <h2 className="info2-title">
          In <span className="highlight2">3</span> Schritten zum erfolgreichen Projektstart mit Qlance
        </h2>
        <div className="info2-divider" />
        <p className="info2-subtitle">
          Von der Projektausschreibung bis zur erfolgreichen Zusammenarbeit: Qlance vereinfacht den gesamten Ablauf für beide Seiten.
        </p>

        <div className="info2-timeline">
          {steps.map((step, index) => (
            <div className={`info2-step ${step.type}`} key={index}>
            <img
              src={`/assets/${step.icon}`}
              alt={step.title}
              className="info2-icon"
            />
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InfoSection2;
